var map = {
	"./FontAwesome.otf": "./app/webpacker/fonts/FontAwesome.otf",
	"./OFN-v2": "./app/webpacker/fonts/OFN-v2.svg",
	"./OFN-v2.eot": "./app/webpacker/fonts/OFN-v2.eot",
	"./OFN-v2.svg": "./app/webpacker/fonts/OFN-v2.svg",
	"./OFN-v2.ttf": "./app/webpacker/fonts/OFN-v2.ttf",
	"./OFN-v2.woff": "./app/webpacker/fonts/OFN-v2.woff",
	"./fontawesome-webfont": "./app/webpacker/fonts/fontawesome-webfont.svg",
	"./fontawesome-webfont.eot": "./app/webpacker/fonts/fontawesome-webfont.eot",
	"./fontawesome-webfont.svg": "./app/webpacker/fonts/fontawesome-webfont.svg",
	"./fontawesome-webfont.ttf": "./app/webpacker/fonts/fontawesome-webfont.ttf",
	"./fontawesome-webfont.woff": "./app/webpacker/fonts/fontawesome-webfont.woff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/webpacker/fonts sync recursive ^\\.\\/.*$";